import React from 'react';
import { Container } from '@material-ui/core';
import loadingImg from '../../../assets/animations/happ_loading.png';
import GitInfo from 'react-git-info/macro';
import TextElement from '../../elements/TextElement';
import styled from 'styled-components';

function HappLoading() {
    const gitInfo = GitInfo();

    return (
        <Container maxWidth="xs" className="container-static">
            <img src={loadingImg} className="partners-loading-img" />
            <RightBottomVersion>
                <TextElement text={gitInfo.tags[0]} type="body-1" uppercase="uppercase" bold={true}/>
            </RightBottomVersion>
        </Container>
    );
};

const RightBottomVersion = styled.div`
    position: absolute;
    bottom: 0;
    right: 35px;
`;

export default HappLoading;
